// @ts-nocheck
import en from "../i18n/lang/en";
import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/login/index";
import Layout from "@/views/layout/layout";
import HomeMain from "@/views/index/mainIndex";

// 不是必须加载的组件使用懒加载

const NotFound = () => import("@/page404");

//super菜单
const companyAdminList = () => import("@/views/super/companyAdmin-list");
const companyAdminForm = () => import("@/views/super/companyAdmin-form");
const sysCompanyList = () => import("@/views/super/sysCompany-list");
const sysCompanyForm = () => import("@/views/super/sysCompany-form");
const instetusionManageList = () =>
  import("@/views/super/instetusionManage-list");
const instetusionManageForm = () =>
  import("@/views/super/instetusionManage-form");
const sysUserList = () => import("@/views/super/sysUser-list");
const sysUserForm = () => import("@/views/super/sysUser-form");

//权限管理
const authoritySysUserList = () => import("@/views/authority/sysUser-list");
const authoritySysUserForm = () => import("@/views/authority/sysUser-form");
const roleManageList = () => import("@/views/authority/roleManage-list");
const roleManageForm = () => import("@/views/authority/roleManage-form");
const sysRoleForm = () => import("@/views/authority/sysRole-form");
const sysRoleList = () => import("@/views/authority/sysRole-list");

//dev菜单
const functionalManage = () => import("@/views/dev/manage/functionalManage");
const buttonManageList = () => import("@/views/dev/manage/buttonManage-list");
const buttonManageForm = () => import("@/views/dev/manage/buttonManage-form");
// const paramConfigList = () => import("@/views/dev/setParam/paramConfig-list");

//crm订单管理
const productManagement = () =>
  import("@/views/CRMORDER/productManagement/productManagement-list.vue"); //产品管理
const orderManagement = () =>
  import("@/views/CRMORDER/orderManagement/orderManagement-list.vue"); //订单管理
const waveManagement = () =>
  import("@/views/CRMORDER/waveManagement/waveManagement-list.vue"); //波次管理
const returnManagement = () =>
  import("@/views/CRMORDER/returnManagement/returnManagement-list.vue"); //退货管理
const expressBusinessType = () =>
  import("@/views/CRMORDER/basicConfiguration/expressBusinessType-list.vue"); //快递业务类型
const expressNumSet  = () =>
import("@/views/CRMORDER/basicConfiguration/expressNumSet.vue"); //快递业务类型
const crmDeptConfiguration = () =>
  import("@/views/CRMORDER/basicConfiguration/crmDeptConfiguration-list.vue"); //快递业务类型
const shippingTemplate = () =>
  import("@/views/CRMORDER/shippingTemplate/shippingTemplate-list.vue"); //发货管理
const ProductIssue = () =>
  import("@/views/ProductDeliveryManagement/ProductIssueQuery/ProductIssue.vue"); //产品出库查询
const retryList = () =>
  import("@/views/CRMORDER/retryList.vue"); //管易异常数据重试
const gyOrderList = () =>
  import("@/views/CRMORDER/gyOrderList/index.vue"); //管易异常数据重试
const guanyiOrder = () => import("@/views/CRMORDER/guanyi/guanyi-list.vue"); //管易

const newGuanyiOrder = () => import("@/views/CRMORDER/newGuanyi/list.vue"); //管易
const InvoiceOrder = () => import("@/views/CRMORDER/newGuanyi/InvoiceOrder/list.vue"); //管易
const returnGoods = () => import("@/views/CRMORDER/newGuanyi/returnGoods/list.vue"); //管易
Vue.use(Router);
let routeName = en.routeName;
let defaultRouter = [
  {
    path: "/",
    redirect: "/index",
    hidden: true,
    children: []
  },
  {
    path: "/login",
    component: Login,
    name: "",
    hidden: true,
    children: []
  },
  {
    path: "/",
    iconCls: "fa fa-dashboard", // 图标样式class
    name: routeName.home,
    component: Layout,
    alone: true,
    children: [
      {
        path: "/index",
        iconCls: "fa fa-dashboard", // 图标样式class
        name: "主页",
        component: HomeMain,
        children: []
      }
    ]
  },
  {
    path: "/404",
    component: NotFound,
    name: "404",
    hidden: true,
    children: []
  }
];
let addRouter = [
  //基础配置
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.basicConfiguration, // 基础配置
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/expressBusinessType", // 快递业务类型
        iconCls: "el-icon-edit-outline",
        name: routeName.expressBusinessType,
        component: expressBusinessType,
        children: []
      },{
        path: "/expressNumSet", // 快递业务类型
        iconCls: "el-icon-edit-outline",
        name: routeName.expressNumSet,
        component: expressNumSet,
        children: []
      },
      {
        path: "/crmDeptConfiguration", // CRM部门配置
        iconCls: "el-icon-edit-outline",
        name: routeName.crmDeptConfiguration,
        component: crmDeptConfiguration,
        children: []
      }
    ]
  },
  //产品出库管理
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.ProductIssueQuery, // 基础配置
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/ProductIssue", // 快递业务类型
        iconCls: "el-icon-edit-outline",
        name: routeName.ProductIssue,
        component: ProductIssue,
        children: []
      },
    ]
  },
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.ProductIssueQuery, // 异常数据处理
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/retryList", // 管易异常数据重试
        iconCls: "el-icon-edit-outline",
        name: routeName.retryList,
        component: retryList,
        children: []
      },
    ]
  },
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.gyOrderList, // 异常数据处理
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/gyOrderList", // 管易异常数据重试
        iconCls: "el-icon-edit-outline",
        name: routeName.gyOrderList,
        component: gyOrderList,
        children: []
      },
    ]
  },
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.guanyiOrder, //管易订单
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/guanyiOrder", //管易订单
        iconCls: "el-icon-edit-outline",
        name: routeName.guanyiOrder,
        component: guanyiOrder,
        children: []
      },{
        path: "/newGuanyiOrder", //管易订单
        iconCls: "el-icon-edit-outline",
        name: routeName.newGuanyiOrder,
        component: newGuanyiOrder,
        children: []
      },{
        path: "/InvoiceOrder", //发货单
        iconCls: "el-icon-edit-outline",
        name: routeName.InvoiceOrder,
        component: InvoiceOrder,
        children: []
      },{
        path: "/returnGoods", //发货单
        iconCls: "el-icon-edit-outline",
        name: routeName.returnGoods,
        component: returnGoods,
        children: []
      },
    ]
  },
  //CRM订单
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.CRMORDER, // CRM订单
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/productManagement", // 产品管理
        iconCls: "el-icon-edit-outline",
        name: routeName.productManagement,
        component: productManagement,
        children: []
      },
      {
        path: "/shippingTemplate", // 发货管理
        iconCls: "el-icon-edit-outline",
        name: routeName.shippingTemplate,
        component: shippingTemplate,
        children: []
      },
      {
        path: "/orderManagement", // 订单查询
        iconCls: "el-icon-edit-outline",
        name: routeName.orderManagement,
        component: orderManagement,
        children: []
      },
      {
        path: "/waveManagement", // 波次管理
        iconCls: "el-icon-edit-outline",
        name: routeName.waveManagement,
        component: waveManagement,
        children: []
      },
      {
        path: "/returnManagement", // 退货管理
        iconCls: "el-icon-edit-outline",
        name: routeName.returnManagement,
        component: returnManagement,
        children: []
      }
    ]
  },
  //权限管理
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.authority, // 权限管理
    component: Layout,
    hidden: false,
    children: [
      {
        path: "/authoritySysUser", // 用户管理
        iconCls: "el-icon-edit-outline",
        name: routeName.authoritySysUser,
        component: authoritySysUserList,
        children: []
      },
      {
        path: "/roleManage", // 角色管理
        iconCls: "el-icon-edit-outline",
        name: routeName.roleManage,
        component: roleManageList,
        children: []
      },
      {
        path: "/sysRoleList", // 用户角色审批
        iconCls: "el-icon-edit-outline",
        name: routeName.sysRoleList,
        component: sysRoleList,
        children: []
      },
      {
        path: "/sysRoleForm", // 用户角色申请
        iconCls: "el-icon-edit-outline",
        name: routeName.sysRoleForm,
        component: sysRoleForm,
        children: []
      },
      /**
       *  表单路由
       */
      {
        path: "/authoritySysUserForm", // 系统用户表单
        hidden: true,
        component: authoritySysUserForm,
        children: []
      },
      {
        path: "/roleManageForm", // 系统用户表单
        hidden: true,
        component: roleManageForm,
        children: []
      }
    ]
  },
  //dev
  {
    path: "/",
    iconCls: "el-icon-tickets", // 图标样式class
    name: routeName.systemManage, //dev
    component: Layout,
    meta: {
      role: ["developer"]
    },
    children: [
      {
        path: "/functionalManage",
        iconCls: "el-icon-edit-outline", // 图标样式class
        name: routeName.functionalManage, // 功能管理
        component: functionalManage,
        children: []
      },
      {
        path: "/buttonManage",
        iconCls: "el-icon-edit-outline", // 图标样式class
        name: routeName.buttonManage, // 按钮管理
        component: buttonManageList,
        children: []
      },
      {
        path: "/buttonManageForm", // 按钮管理表单
        hidden: true,
        component: buttonManageForm,
        children: []
      }
      // {
      //   path: "/onlineUserManagement",
      //   iconCls: "el-icon-edit-outline", // 图标样式class
      //   name: routeName.onlineUserManagement, // 在线用户管理
      //   component: onlineUserManagement,
      //   children: []
      // },
      // {
      //   path: "/interFaceperFormance",
      //   iconCls: "el-icon-edit-outline", // 图标样式class
      //   name: routeName.interFaceperFormance, // 接口性能分析
      //   component: interFaceperFormance,
      //   children: []
      // },
      // {
      //   path: "/paramConfig", // 参数配置
      //   iconCls: "el-icon-edit-outline",
      //   name: routeName.paramConfig,
      //   component: paramConfigList,
      //   children: []
      // }
    ]
  },
  //企业管理
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.enterpriseManage, // 企业管理
    component: Layout,
    meta: {
      role: ["super"]
    },
    children: [
      {
        path: "/sysCompany", // 公司管理
        iconCls: "el-icon-edit-outline",
        name: routeName.sysCompany,
        component: sysCompanyList,
        children: []
      },
      {
        path: "/companyAdmin", // 公司管理员管理
        iconCls: "el-icon-edit-outline",
        name: routeName.companyAdmin,
        component: companyAdminList,
        children: []
      },
      /**
       *  表单路由
       */
      {
        path: "/companyAdminForm", // 公司管理员表单
        hidden: true,
        component: companyAdminForm,
        children: []
      },
      {
        path: "/sysCompanyForm", // 公司表单
        hidden: true,
        component: sysCompanyForm,
        children: []
      }
    ]
  },
  //门店管理
  {
    path: "/",
    iconCls: "el-icon-tickets",
    name: routeName.storeManage, // 门店管理
    component: Layout,
    meta: {
      role: ["super"]
    },
    children: [
      {
        path: "/instetusionManage", // 门店管理
        iconCls: "el-icon-edit-outline",
        name: routeName.instetusionManage,
        component: instetusionManageList,
        children: []
      },
      {
        path: "/sysUser", // 门店管理员
        iconCls: "el-icon-edit-outline",
        name: routeName.sysUser,
        component: sysUserList,
        children: []
      },
      /**
       *  表单路由
       */
      {
        path: "/instetusionManageForm", // 门店管理表单
        hidden: true,
        component: instetusionManageForm,
        children: []
      },
      {
        path: "/sysUserForm", // 门店管理员表单
        hidden: true,
        component: sysUserForm,
        children: []
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
    children: []
  }
];
export default new Router({
  routes: defaultRouter,
  mode: "history"
});
export { defaultRouter, addRouter };



// WEBPACK FOOTER //
// ./src/router/index.js